module.exports = __webpack_public_path__ + "static/media/hostplatform-logo.a24f2d7c.png";